import {
  Button,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@mui/material'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { memo } from 'react'
import { isEqual } from 'lodash'
import CurrencyField from '../../../../../components/CurrencyField/CurrencyField'
import { metodoPrograma } from '../../../../../components/api'

const validationSchema = Yup.object({
  vlAbertura: Yup.number().optional(),
  dsCaixa: Yup.string().max(
    120,
    'A descrição deve ter no maximo 120 caracteres',
  ),
})

const ModalAberturaCaixa = ({ data, close }) => {
  const onSubmit = async (values, { setSubmitting }) => {
    const payload = {
      idCaixa: values.idCaixa,
      idLocalAtendimento: data?.idLocalAtendimento,
      idRegistro: data?.idRegistro,
      vlAbertura: values.vlAbertura || 0.0,
      dsCaixa: values.dsCaixa || undefined,
    }

    const res = await metodoPrograma(
      'aberturaDeCaixa',
      payload,
      'CtrlCaixaFechamento',
    )
    setSubmitting(false)
    if (res?.status) {
      close(true)
    }
  }

  return (
    <Formik
      initialValues={{
        idCaixa: undefined,
        vlAbertura: '',
        dsCaixa: '',
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        isSubmitting,
        submitForm,
        values,
        setFieldValue,
        setFieldTouched,
        errors,
        touched,
      }) => (
        <Form>
          <Dialog
            open={true}
            onClose={() => close(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Abertura de Caixa</DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CurrencyField
                    label="Valor da Abertura"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values.vlAbertura}
                    onChange={(v) => {
                      setFieldValue('vlAbertura', v)
                      setFieldTouched('vlAbertura', true)
                    }}
                    error={touched.vlAbertura && !!errors.vlAbertura}
                    helperText={touched.vlAbertura && errors.vlAbertura}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="dsCaixa"
                    label="Descrição "
                    fullWidth
                    multiline
                    minRows={3}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.dsCaixa}
                    onChange={(e) => setFieldValue('dsCaixa', e.target.value)}
                    onBlur={() => setFieldTouched('dsCaixa', true)}
                    error={touched.dsCaixa && !!errors.dsCaixa}
                    helperText={touched.dsCaixa && errors.dsCaixa}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => close(false)}
                color="secondary"
                variant="contained"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  )
}

export default memo(ModalAberturaCaixa, isEqual)
